import { connect } from 'react-redux';
import { formVerificationSetGame } from '../../../store/forms/forms.actions';
import { Implementation } from './implementation';

const mapStateToProps = (state) => {
	return {
		game: state.forms.bet_verification.game,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		setGame: (game) => dispatch(formVerificationSetGame(game)),
	};
};

const ImplementationContainer = connect(
	mapStateToProps,
	mapDispatchToProps,
)(Implementation);

export { ImplementationContainer };
